import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks, siteName } from '@/mocks/home';

export default function SiteNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.hash]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-background-50/70 backdrop-blur-sm border-b border-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer" aria-label={`${siteName}首页`}>
          <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading text-xl md:text-2xl leading-none">
            17
          </span>
          <span className="font-heading text-xl md:text-2xl text-foreground-950 tracking-wide">{siteName}</span>
        </Link>

        <ul className="hidden md:flex items-center gap-1 lg:gap-2">
          {navLinks.map((l) => (
            <li key={l.label}>
              <Link
                to={l.to}
                className="px-3 lg:px-4 py-2 text-sm font-medium text-foreground-700 rounded-md hover:text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/guide"
            className="text-sm font-medium text-foreground-600 hover:text-foreground-900 whitespace-nowrap cursor-pointer"
          >
            投稿前须知
          </Link>
          <Link
            to="/submit"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-bold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-fill text-base"></i>
            进入投稿入口
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
          aria-expanded={menuOpen}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-900 hover:bg-background-200 transition-colors cursor-pointer"
        >
          <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <ul className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <li key={l.label}>
                <Link
                  to={l.to}
                  className="block px-3 py-3 text-base font-medium text-foreground-800 rounded-md hover:bg-background-100 hover:text-primary-600 transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
          <Link
            to="/submit"
            className="mt-3 flex items-center justify-center gap-1.5 w-full px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-bold hover:bg-primary-600 transition-colors"
          >
            <i className="ri-send-plane-fill text-base"></i>
            进入投稿入口
          </Link>
        </div>
      )}
    </header>
  );
}